<!--
  This component handles the rendering of warning and error messages. It does not
  control application flow or perform any blocking or non-blocking actions.
-->
<template>
  <div style="position: relative">
    <Message v-model="showErr" :message="message" color="error" @close="closeMessage('error')" />
    <Message
      v-model="showSuccess"
      :message="message"
      color="success"
      @close="closeMessage('success')"
    />
    <Message
      v-model="showWarn"
      :message="message"
      color="warning"
      @close="closeMessage('warn')"
    ></Message>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { COMPANY_SUPPORT_EMAIL, ERROR_APP, ERROR_USER } from '@/data/constants/messages';
import Message from './Message';
import { ErrorKeys as K } from '@/data/constants';

export default {
  name: 'Alerts',
  components: {
    Message,
  },

  data() {
    return {
      COMPANY_SUPPORT_EMAIL,
    };
  },

  methods: {
    ...mapMutations('error', { setErrorState: 'setErrorState' }),

    closeMessage(type) {
      const key = type === 'error' ? K.ERROR : type === 'success' ? K.SUCCESS : K.WARN;

      this.setErrorState({ key, val: false });
    },
  },

  computed: {
    ...mapState('error', {
      error: (state) => state[K.ERROR],
      warn: (state) => state[K.WARN],
      success: (state) => state[K.SUCCESS],
      message: (state) => state[K.MESSAGE],
    }),

    showErr: {
      get() {
        return this.error;
      },

      set(val) {
        const key = K.ERROR;
        this.setErrorState({ key, val });
      },
    },

    showSuccess: {
      get() {
        return this.success;
      },

      set(val) {
        const key = K.SUCCESS;
        this.setErrorState({ key, val });
      },
    },

    showWarn: {
      get() {
        return this.warn;
      },

      set(val) {
        const key = K.WARN;
        this.setErrorState({ key, val });
      },
    },

    errorText() {
      if (this.error) {
        return ERROR_APP;
      }
      return ERROR_USER;
    },
  },
};
</script>

<style>
.v-snack__wrapper {
  max-width: 400px !important;
  padding-right: 4px !important;
}
</style>
